import React from 'react';
import { Hero } from '../components/Hero';
import { WhyChoose } from '../components/WhyChoose';
import { ServiceCards } from '../components/ServiceCards';
import { ServiceAreas } from '../components/ServiceAreas';
import { Industries } from '../components/Industries';
import { Process } from '../components/Process';
import { Testimonials } from '../components/Testimonials';
import { FaqSection } from '../components/FaqSection';
import { BeforeAfterGallery } from '../components/BeforeAfterGallery';
import { ContactSection } from '../components/ContactSection';
import { useLanguage } from '../contexts/LanguageContext';
import { usePageMeta } from '../hooks/usePageMeta';
import { ui } from '../data/ui';
import { buildPageSchema } from '../utils/schema';
export function Home() {
  const {
    t,
    lang
  } = useLanguage();
  usePageMeta({
    title: t(ui.meta.title),
    description: t(ui.meta.description),
    lang,
    schema: buildPageSchema(lang)
  });
  return <>
      <Hero data-id="element-396" data-mp="30wjaok4gik28" />
      <WhyChoose data-id="element-397" data-mp="30xb5hsq8cdrg" />
      <ServiceCards data-id="element-398" data-mp="30vqak2006st2" />
      <ServiceAreas data-id="element-399" data-mp="30w04u1s2zm4k" />
      <Industries data-id="element-400" data-mp="30uf9i9xxzz5n" />
      <Process data-id="element-401" data-mp="2vxyd6sglaehh" />
      <Testimonials data-id="element-402" data-mp="2vxf5s5okf8hp" />
      <FaqSection data-id="element-403" data-mp="2vyzxzoneqfce" />
      <BeforeAfterGallery data-id="element-404" data-mp="2vyhx2epsvcy5" />
      <ContactSection data-id="element-405" data-mp="2qylo0128wvbq" />
    </>;
}